import { Navigate } from "react-router-dom";
import SignolUtils from "@src/utils/signolUtils";
import { SIGNOL_STAGE } from "@src/constants/constants";
import { ManagerContainer } from "@src/pages/manager/managerContainer";
import {
  ManagerOverviewPage,
  BehavioursPage as ManagerBehavioursPage,
  ActivityPage as ManagerActivityPage,
  ProfilePage as ManagerProfilePage,
  ManagerSupportPage,
  DataAccessPage,
} from "@src/pages/manager/index";
import { managerLoader } from "@src/loaders/index";
import Protected from "./Protected";

const managerRootLoader = async (req) => {
  return {
    // dict of promises so we can display loading screen
    initialData: managerLoader(req), // required
    //nonCriticalData: ...
  };
};

/** @type {import("react-router").RouteObject} */
export const managerRoutes = {
  path: "manager",
  loader: managerRootLoader,
  element: (
    <Protected allowedUserType={"manager"}>
      <ManagerContainer />
    </Protected>
  ),
  children: [
    {
      index: true,
      element: <Navigate to="overview" />,
    },
    {
      path: "overview",
      pageTitle: "Overview",
      menuIcon: "chartColumnOutline",
      menuIconActive: "chartColumnFilled",
      element: <ManagerOverviewPage />,
    },
    {
      pageTitle: "Behaviours",
      path: "behaviours",
      menuIcon:
        SignolUtils.getIndustryIcon(SignolUtils.getIndustry(), false) ||
        "dashboard",
      menuIconActive:
        SignolUtils.getIndustryIcon(SignolUtils.getIndustry(), true) ||
        "dashboard",
      menuIconIsIndustryIcon: true,
      element: <ManagerBehavioursPage />,
    },
    {
      pageTitle: "Engagement",
      menuIcon: "scribbleOutline",
      menuIconActive: "scribbleFilled",
      path: "activity",
      element: <ManagerActivityPage />,
    },
    // {
    //   separator: true,
    // },
    {
      pageTitle: "Data Download",
      path: "data",
      menuIcon: "downloadSquareOutline",
      menuIconActive: "downloadSquareFilled",
      element: <DataAccessPage />,
      // only for MARITIME managers for now
      hidden: SignolUtils.getIndustry() === "aviation",
    },
    {
      pageTitle: "Support",
      path: "support",
      menuIcon: "questionBlobOutline",
      menuIconActive: "questionBlobFilled",
      element: <ManagerSupportPage />,
    },
    {
      path: "profile",
      element: <ManagerProfilePage />,
    },
  ],
};
